import { useEffect } from "react";
import { DatePicker, Form } from "rsuite";
import { useAppDispatch } from "../core/redux";

interface IReduxAction<T> {
  payload: T;
  type: string;
}

interface IRequiredPRops {
  children: React.ReactNode;
  name: "start" | "end";
  value: Date | null;
}

interface IReduxActions {
  setStartDate: (payload: string | null) => IReduxAction<typeof payload>;
  setEndDate: (payload: string | null) => IReduxAction<typeof payload>;
  goToPage: (payload: number) => IReduxAction<typeof payload>;
}

interface IImplicitProps extends IRequiredPRops {
  action: IReduxActions;
  onChange?: (date: Date) => void;
}

interface IExplicitProps extends IRequiredPRops {
  onChange: (date: Date) => void;
  action?: IReduxActions;
  setDate?: (payload: string | null) => IReduxAction<typeof payload>;
}

export function CustomDatePicker({
  children,
  action,
  onChange,
  name,
  value,
}: IImplicitProps | IExplicitProps) {
  const dispatch = useAppDispatch();

  const handleChange = (date: Date) => {
    if (!action) {
      return;
    }
    if (name === "start") {
      date.setHours(0, 0, 0, 0);
      dispatch(action.goToPage(1));
      dispatch(action?.setStartDate(date ? date.toISOString() : null));
    } else {
      date.setHours(23, 59, 59, 0);
      dispatch(action.goToPage(1));
      dispatch(action.setEndDate(date ? date.toISOString() : null));
    }
  };

  useEffect(() => {
    return () => {
      if (action) {
        if (name === "start") {
          dispatch(action.setStartDate(null));
        } else {
          dispatch(action.setEndDate(null));
        }
      }
    };
  }, [action, name, dispatch]);

  return (
    <Form.Group className="col-md-6 col-12">
      <Form.ControlLabel>{children}:</Form.ControlLabel>
      <DatePicker
        key={value?.getMilliseconds()}
        format="MM-dd-yyyy"
        onChange={onChange ? onChange : handleChange}
        value={value!}
        style={{ width: "100%" }}
      />
    </Form.Group>
  );
}
